import { useI18n } from 'vue-i18n'
import type { VirtualAgentSummary } from 'shared/src'
import { AgentStatus } from 'shared/src'

export const useBadgeContent = () => {
  const { t } = useI18n()

  const getBadgeContent = (agent: VirtualAgentSummary): string => {
    // Check if agentStatus is valid
    const validStatuses = Object.values(AgentStatus)
    if (!agent.agentStatus || !validStatuses.includes(agent.agentStatus)) {
      return '-'
    }

    // If problematicCallsCount is 0, null, undefined, or NaN, always show "Stable"
    if (!agent.problematicCallsCount) {
      return t(AgentStatus.Stable)
    }

    const label = t(agent.agentStatus)
    return `${label} (${String(agent.problematicCallsCount)})`
  }
  return { getBadgeContent }
}
